import axiosInstance from "../../../shared/api/axiosInstance";
import { configReq } from "../../../shared/lib/functions";
import { normalizePromotionEnvelope } from "./promotions";

const base = "admin/v2/PromotionReservations";
const config = (token, signal) => ({ ...configReq(token), signal, timeout: 20000 });
const fields = new Set(["customerUserId", "boothId", "advertisementId", "planName", "amountDisplay", "startsDisplay", "endsDisplay", "remainingDisplay", "stateDisplay", "paymentOrderId", "state"]);
const states = new Set(["draft", "held", "pending", "paid", "failed", "stopped", "refunded"]);
function reservation(row) {
  if (typeof row?.id !== "string" || typeof row.planName !== "string" || !states.has(row.state)
    || ![row.customerUserId, row.boothId, row.advertisementId, row.amountMinor, row.version].every(Number.isSafeInteger)
    || !Number.isFinite(Date.parse(row.startsAt)) || !Number.isFinite(Date.parse(row.endsAt))
    || typeof row.stopped !== "boolean" || !Array.isArray(row.placements)) throw new Error("invalid-reservation");
  return row;
}
export async function getPromotionReservations(token, query, signal) {
  const params = new URLSearchParams({ page: String(query.page), limit: String(query.limit) });
  if (query.search) params.set("search", query.search);
  if (query.state) params.set("state", query.state);
  if (query.bannersOnly) params.set("bannersOnly", "true");
  const data = normalizePromotionEnvelope((await axiosInstance.get(`${base}?${params}`, config(token, signal))).data);
  if (!Array.isArray(data.data) || !Number.isSafeInteger(data.total) || !Array.isArray(data.header)) throw new Error("invalid-reservation-list");
  const headers = data.header.map((item) => {
    if (!fields.has(item.name) || !item.title?.trim()) throw new Error("invalid-reservation-headers");
    return { ...item, type: "string", showInList: item.showInList === true, hasFilter: item.hasFilter === true, colSpan: 1 };
  });
  if (!headers.some((item) => item.showInList)) throw new Error("invalid-reservation-headers");
  return { rows: data.data.map(reservation), total: data.total, headers, serverNow: data.serverNow ? Date.parse(data.serverNow) : Date.now() };
}
export async function stopPromotionReservation(token, row) {
  return reservation(normalizePromotionEnvelope((await axiosInstance.post(`${base}/${row.id}/stop`, { version: row.version }, config(token))).data));
}
export async function refundPromotionReservation(token, row, request) {
  return normalizePromotionEnvelope((await axiosInstance.post(`${base}/${row.id}/refund`, request, config(token))).data);
}
